import { render, staticRenderFns } from "./SessionExpiredModal.vue?vue&type=template&id=588a453e&scoped=true"
import script from "./SessionExpiredModal.vue?vue&type=script&lang=js"
export * from "./SessionExpiredModal.vue?vue&type=script&lang=js"
import style0 from "./SessionExpiredModal.vue?vue&type=style&index=0&id=588a453e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588a453e",
  null
  
)

export default component.exports